exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "div.stupid-carousel-container{width:100%;position:relative;overflow:hidden}div.stupid-carousel-container div.stupid-carousel-slider{position:relative}div.stupid-carousel-container div.stupid-carousel-slider ul.stupid-carousel-list{box-sizing:border-box;display:flex;flex-flow:row;flex-grow:1;padding:0;margin:0}div.stupid-carousel-container div.stupid-carousel-slider ul.stupid-carousel-list li.stupid-carousel-slide{box-sizing:border-box;flex-shrink:0;display:flex;list-style-type:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/core.scss
// module id = 14
// module chunks = 0